import { Component, Prop, Vue } from 'vue-property-decorator';

import { ExchangeRate } from '@/core/currency/interfaces';

@Component
export default class ExchangeDetails extends Vue {
    @Prop(Object)
    exchangeRate: ExchangeRate;

    @Prop()
    exchangeAmount: string;
}
